export const SCROLL_THROTTLING_DELAY = 100;
export const SCROLL_CLICK_DEAD_ZONE = 2;
